// @flow
import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import BlankSlate from 'bizom-mui/lib/BlankSlate';
import NoInternetIcon from '@material-ui/icons/SignalCellularConnectedNoInternet4Bar';
import { RETRY } from 'constants/strings';
import {
  NO_NETWORK,
  PLEASE_CHECK_INTERNET_CONNECTIVITY,
} from 'constants/errors';

const ResponsiveDialog = withMobileDialog()(Dialog);

const styles = ({ extras, palette }) => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const NoConnection = ({ classes, history }: Props) => {
  const [isOffline, setNetworkState] = useState(!navigator.onLine);

  useEffect(() => {
    if (process.env.REACT_APP_MOCK) return;

    window.addEventListener('offline', () => {
      setNetworkState(true);
    });

    window.addEventListener('online', () => {
      setNetworkState(false);
    });
  }, []);

  if (process.env.REACT_APP_MOCK) return null;

  return (
    <ResponsiveDialog open={isOffline}>
      <DialogContent className={classes.content}>
        <BlankSlate
          dense
          title={NO_NETWORK}
          subtitle={PLEASE_CHECK_INTERNET_CONNECTIVITY}
          image={<NoInternetIcon color="secondary" fontSize="large" />}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => window.location.reload()}
          >
            {RETRY}
          </Button>
        </BlankSlate>
      </DialogContent>
    </ResponsiveDialog>
  );
};

export default withRouter(withStyles(styles)(NoConnection));
